import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { NAV } from "../lib/nav";

export const Footer = () => (
  <footer className="relative overflow-hidden bg-navy pt-24 pb-10" data-testid="footer">
    <div className="container-luxe">
      <Link to="/contact" className="block" data-testid="footer-cta">
        <motion.span
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="block text-left font-serif text-[15vw] font-light leading-[0.85] tracking-tight text-cream transition-colors hover:text-gold lg:text-[12vw]"
        >
          Inicia tu <span className="italic text-gold">viaje</span>
        </motion.span>
      </Link>

      <div className="mt-20 flex flex-col gap-10 border-t border-gold/20 pt-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-xs">
          <span className="block font-serif text-xl text-cream">Academia</span>
          <span className="block text-[0.65rem] uppercase tracking-luxe text-gold">
            Desde el Primer Latido™
          </span>
          <p className="mt-4 text-sm font-light leading-relaxed text-cream/50">
            Conocimiento profundo, claro y accesible para una vida más consciente.
          </p>
        </div>

        <nav className="grid grid-cols-2 gap-x-10 gap-y-3 sm:grid-cols-3">
          {NAV.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-sm text-cream/70 transition-colors hover:text-gold"
              data-testid={`footer-link-${l.to}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>

      <div className="mt-10 flex flex-col gap-2 text-xs text-cream/40 sm:flex-row sm:justify-between">
        <span>© {new Date().getFullYear()} Academia Desde el Primer Latido™. Todos los derechos reservados.</span>
        <span>Diseñado con conciencia.</span>
      </div>
    </div>
  </footer>
);
